import React from "react";
import { ListItemProps, ListV2 } from "../list/ListV2";
import { SearchRequest } from "../model/search/UserSearchRequestV1";
import { PageResponse } from "../paging/Paging.Model";
import { VideoApi } from "./Video.Api";
import { ListItemLayoutDefault } from "../list/ListItem.Layout";
import { VideoBunnyCdn } from "./Video.Model";
import TimeAgo from "timeago-react";
import { EBButton } from "../components/common/EBButton";

interface VideoListProps {
  onSelectVideo?: (video: VideoBunnyCdn) => void;
}

export function VideoList(props: VideoListProps) {
  return (
    <div className="VideoList">
      <ListV2
        onFetch={function (
          searchRequest?: SearchRequest
        ): Promise<PageResponse<any>> {
          return VideoApi.listVideos().executeV2();
        }}
        ItemLayoutComponent={ListItemLayoutDefault}
        itemNode={(itemProps: ListItemProps) => {
          let vdo = itemProps.item as VideoBunnyCdn;
          return (
            <div
              className="cursor-pointer"
              onClick={() => {
                if (props.onSelectVideo) {
                  props.onSelectVideo(vdo);
                }
              }}
            >
              {vdo.dl}
              {vdo.createdAt && (
                <div className="text-muted small">
                  <TimeAgo datetime={vdo.createdAt} />
                </div>
              )}
            </div>
          );
        }}
      />
    </div>
  );
}
